const billingHistory = {
  path: 'provider',
  component: () =>
    import('@/views/provider/billing-history-management/Wrapper.vue'),
  children: [
    {
      path: '/provider/billing-history',
      name: 'billingHistorySearch',
      component: () =>
        import('@/views/provider/billing-history-management/Main.vue'),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.provider.billinghistory'],
        },
      },
    },
    {
      path: '/provider/billing-history/:billId',
      name: 'billingHistoryManagement',
      component: () =>
        import(
          '@/views/provider/billing-history-management/BillingHistoryManagement.vue'
        ),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.provider.billinghistory'],
        },
      },
    },
  ],
};

export default billingHistory;
